module.exports = __webpack_public_path__ + "static/media/banner1-julho2024.25df77a2.jpg";